import React from "react";
import { Box, Button, HStack, Text, VStack, Card, CardBody, Badge, Icon, Center } from "@chakra-ui/react";
import { ViewIcon, DeleteIcon, LinkIcon } from "@chakra-ui/icons";

const ConnectionsList: React.FC<{
  connections: any[];
  onView: (id: string) => void;
  onDelete: (id: string) => void;
}> = ({ connections, onView, onDelete }) => {
  const hasConnections = connections && connections.length > 0;
  
  return (
    <Box w="full" mb="14px">
      <Text fontSize="lg" fontWeight={600} mb={4} color="white">
        {hasConnections ? "Your connected accounts" : "Connected accounts"}
      </Text>
      
      {!hasConnections ? (
        <Card w="full" variant="outline" bg="gray.800" borderColor="gray.600">
          <CardBody p={8}>
            <Center>
              <VStack spacing={4}>
                <Icon as={LinkIcon} boxSize={8} color="gray.500" />
                <VStack spacing={2} textAlign="center">
                  <Text fontWeight={600} color="gray.300">No accounts connected yet</Text>
                  <Text fontSize="sm" color="gray.500" maxW="sm">
                    Connect your first brokerage account above to automatically sync your portfolio data.
                  </Text>
                </VStack>
              </VStack>
            </Center>
          </CardBody>
        </Card>
      ) : (
        <VStack alignItems="flex-start" spacing={3}>
          {connections.map((c: any) => (
            <Card key={c.id} w="full" variant="outline" bg="gray.800" borderColor="gray.600">
              <CardBody p={4}>
                <HStack w="full" justifyContent="space-between" alignItems="center">
                  <VStack alignItems="flex-start" spacing={2} flex={1}>
                    <HStack spacing={3} alignItems="center">
                      <Text fontWeight={600} fontSize="md" color="white">
                        {c.brokerage?.display_name || c.brokerage?.name || c.brokerage?.slug}
                      </Text>
                      <Badge 
                        colorScheme={c.disabled ? "red" : "green"} 
                        variant="subtle"
                        size="sm"
                      >
                        {c.disabled ? "Disabled" : "Active"}
                      </Badge>
                    </HStack>
                    <Text fontSize="xs" color="gray.400">
                      Connection ID: {c.id}
                    </Text>
                  </VStack>
                  
                  <HStack spacing={2}>
                    <Button 
                      size="sm" 
                      variant="ghost"
                      leftIcon={<ViewIcon />}
                      onClick={() => onView(c.id)}
                      colorScheme="blue"
                    >
                      View
                    </Button>
                    <Button 
                      size="sm" 
                      variant="ghost"
                      leftIcon={<DeleteIcon />}
                      onClick={() => onDelete(c.id)}
                      colorScheme="red"
                    >
                      Remove
                    </Button>
                  </HStack>
                </HStack>
              </CardBody>
            </Card>
          ))}
        </VStack>
      )}
    </Box>
  );
};

export default ConnectionsList;


